module.exports = __webpack_public_path__ + "static/karl-kohler-dV1S_uKSb6A-unsplash-5bab4303f7bb549292ede9d51a5d3184.png";